import React, { useEffect, useState } from "react";
import { ListItemText, MenuItem, Typography, Box, IconButton, CircularProgress, useTheme } from "@mui/material";
import { Check, PersonSearchOutlined, ClearAll } from "@mui/icons-material";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// Filtro da lista de tickets por ATENDENTE (só administrador). Pedido da
// Insetisan (abr/2024): supervisão quer ver os atendimentos de uma pessoa.
// Vale nas abas Atendendo e Resolvidos — o Aguardando não tem dono.
const UserFilterMenuItems = ({ selectedUserIds = [], onChange }) => {
  const theme = useTheme();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let ativo = true;
    const carregar = async () => {
      setLoading(true);
      try {
        // /users é paginado; junta todas as páginas (equipe pode ter 40+ pessoas)
        let page = 1;
        let todos = [];
        let hasMore = true;
        while (hasMore && page <= 20) {
          const { data } = await api.get("/users", { params: { pageNumber: page } });
          todos = todos.concat(data.users || []);
          hasMore = !!data.hasMore;
          page += 1;
        }
        if (ativo) {
          setUsers(todos.sort((a, b) => (a.name || "").localeCompare(b.name || "", "pt-BR")));
        }
      } catch (err) {
        toastError(err);
      } finally {
        if (ativo) setLoading(false);
      }
    };
    carregar();
    return () => {
      ativo = false;
    };
  }, []);

  const handleToggle = userId => {
    onChange(
      selectedUserIds.includes(userId)
        ? selectedUserIds.filter(id => id !== userId)
        : [...selectedUserIds, userId]
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          borderBottom: `1px solid ${theme.palette.divider}`
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: "bold", display: "flex", alignItems: "center", gap: "8px" }}>
          <PersonSearchOutlined fontSize="small" />
          Filtrar por atendente
        </Typography>
        <IconButton size="small" onClick={() => onChange([])} title="Limpar filtro">
          <ClearAll fontSize="small" />
        </IconButton>
      </Box>
      <Typography variant="caption" color="textSecondary" sx={{ display: "block", px: 2, pt: 1 }}>
        Vale para Atendendo e Resolvidos.
      </Typography>
      {loading && (
        <Box display="flex" justifyContent="center" p={1}>
          <CircularProgress size={20} />
        </Box>
      )}
      <Box sx={{ maxHeight: 360, overflowY: "auto" }}>
        {users.map(u => (
          <MenuItem key={u.id} dense onClick={() => handleToggle(u.id)}>
            <ListItemText primary={u.name} />
            {selectedUserIds.includes(u.id) && <Check fontSize="small" color="primary" />}
          </MenuItem>
        ))}
      </Box>
    </>
  );
};

export default UserFilterMenuItems;
